module.exports = __webpack_public_path__ + "static/mobile-index-f2994cedef6d5a421737b6c504d9b3b2.png";